import store from 'source/store';

export default [
    {
        path: '/organization',
        name: 'organization',
        component: () => import('source/pages/root/OrganizationPageGroup.vue'),
        meta: {
            title: 'Organization - HQZen',
            canDisplayGlobalModals: true,
            isOrganizationRoute: true,
        },

        beforeEnter: (to, from, next) => {
            const { is_organizational_exec, is_workforce_exec } = store.state.auth.user.user_profile;
            if (!is_organizational_exec && !is_workforce_exec) next({ name: 'page-not-found', replace: true });
            else next();
        },

        children: [
            {
                path: 'executives',
                name: 'executives-management',
                component: () =>
                    import(
                        'source/pages/organization/ManagementExecutivesPage.vue'
                    ),
                props: true,
                meta: {
                    title: 'Executives - HQZen',
                    canDisplayGlobalModals: true,
                    isOrganizationRoute: true,
                },
            },
            {
                path: 'workforce-facilities',
                name: 'workforce-facilities-management',
                component: () =>
                    import(
                        'source/pages/organization/ManagementWorkforcesPage.vue'
                    ),
                props: true,
                meta: {
                    title: 'Workforce Facilities - HQZen',
                    canDisplayGlobalModals: true,
                    isOrganizationRoute: true,
                },
            },
            {
                path: 'career-policies',
                name: 'employment-policies-management',
                component: () =>
                    import(
                        'source/pages/organization/CareerPolicyListPage.vue'
                    ),
                props: true,
                meta: {
                    title: 'Career Policies - HQZen',
                    canDisplayGlobalModals: true,
                    isOrganizationRoute: true,
                },
            },
            {
                path: 'create-career-policy',
                name: 'create-career-policy',
                component: () =>
                    import(
                        'source/pages/organization/career-policy/CreateCareerPolicyPage.vue'
                    ),
                props: true,
                meta: {
                    title: 'Create Career Policies - HQZen',
                    canDisplayGlobalModals: true,
                    isOrganizationRoute: true,
                },
            },
            {
                path: 'exit-interviews/details/:id',
                name: 'employment-policies-exit-interview-details',
                component: () => {
                    return import (
                        'source/pages/employers/staff/sub-sections/exit-interview/ExitInterviewDetailsPage.vue'
                    );
                },
                props: true,
                meta: {
                    title: 'Exit Interviews Details - HQZen',
                    canDispladashboardyGlobalModals: true,
                },
            },
            {
                path: 'career-policies/:employment_policy_id',
                name: 'company-policy-org-view',
                component: () =>
                    import (
                        'source/pages/employers/campaign-policy/CampaignPolicyView.vue'
                    ),
                props: true,
                meta: {
                    title: 'HR Policy - HQZen',
                    canDisplayGlobalModals: true,
                    isOrganizationRoute: true,
                },
            },
            {
                path: 'career-policies/:employment_policy_id',
                name: 'view-amendment',
                component: () =>
                    import (
                        'source/pages/organization/ViewAmendmentPage.vue'
                    ),
                props: true,
                meta: {
                    title: 'Career Policy Amendment Summary - HQZen',
                    canDisplayGlobalModals: true,
                    isOrganizationRoute: true,
                },
            },
            {
                path: 'organization-hr-admins',
                name: 'hr-admins-management',
                component: () =>
                    import(
                        'source/pages/organization/ManagementHRAdminsPage.vue'
                    ),
                props: true,
                meta: {
                    title: 'HR Admins - HQZen',
                    canDisplayGlobalModals: true,
                    isOrganizationRoute: true,
                },
            },
            {
                path: 'memorandums',
                name: 'organization-memorandums',
                component: () =>
                    import ('source/pages/memorandums/MemorandumsPage.vue'),
                props: true,
                meta: {
                    title: 'Memorandums - HQZen',
                    canDisplayGlobalModals: true,
                    isOrganizationRoute: true,
                },
            },
            {
                path: 'memorandums/:memoId',
                name: 'organization-memorandum-details',
                component: () =>
                    import (
                        'source/pages/memorandums/MemorandumDetailsPage.vue'
                    ),
                props: true,
                meta: {
                    title: 'Memorandum Details - HQZen',
                    canDisplayGlobalModals: true,
                    isOrganizationRoute: true,
                },
            },
            {
                path: 'company-rules',
                name: 'company-rules',
                component: () =>
                    import(
                        'source/pages/organization/CompanyRulesPage.vue'
                    ),
                props: true,
                meta: {
                    title: 'Company Rules - HQZen',
                    canDisplayGlobalModals: true,
                    isOrganizationRoute: true,
                },
            },
        ],
    },
];
